import {
  getCurrencyMinorUnitExponent,
  getCurrencySymbol,
  type CurrencyCode,
} from '@dinewise/utils';

export const resolveCurrencyFieldOptions = (
  currencyCode: CurrencyCode = 'USD',
  decimals?: number,
) => ({
  decimals: decimals ?? getCurrencyMinorUnitExponent(currencyCode),
  currencySymbol: getCurrencySymbol(currencyCode),
});

export const getCurrencySymbolInputPadding = (currencySymbol: string) => {
  const length = [...currencySymbol].length;

  if (length <= 1) {
    return 'pl-6';
  }
  if (length === 2) {
    return 'pl-9';
  }
  if (length === 3) {
    return 'pl-11';
  }

  return 'pl-12';
};
